import React from 'react';
import { context } from './components/AppContext';
import LoginWindow from './components/LoginWindow';
import Main from './components/Main';

class App extends React.Component {
    state={
        otpRequired: false
    };

    render() {
        let main = (
            <LoginWindow
                style={ { padding: 50 } }
                otpRequired={ this.state.otpRequired }
                onSubmit={ (formData) => {
                    context.login(formData)
                        .then(res => {
                            if (res === true)
                                this.setState({});
                            if (typeof res === "object" && res.code === 407)
                                this.setState({ otpRequired: true });
                        })
                }}
            />
        );
        
        if (context.accessToken) {
            main = (
                <Main />
            );
        }

        return <div data-testid="App">{ main }</div>;
    }
}

export default App;
